import React, { useState } from 'react';
import { IntegrationType, TopicStyles } from './mixins/mixins';
import { IntegrationsArray } from './mixins/intergrationOptions';

export const IntegraionStyle = ({
	style,
	setStyle
}: {
	style: TopicStyles;
	setStyle: (style: TopicStyles) => void;
}) => {
	return (
		<div className="flex justify-center w-full ">
			<div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 justify-items-start gap-y-4 gap-x-12">
				{IntegrationsArray.map((item) => (
					<Checkbox
						name={item.name}
						slugName={item.nameSlug}
						style={style}
						setStyle={setStyle}
					/>
				))}
			</div>
		</div>
	);
};

const Checkbox = ({
	name,
	slugName,
	style,
	setStyle
}: {
	name: string;
	slugName: string;
	style: TopicStyles;
	setStyle: (style: TopicStyles) => void;
}) => {
	const checkIfNameInStyleIntegrations = () => {
		const item = style.integrationsStyle.find((item) => item.name === name);
		if (item != null) return true;
		return false;
	};
	const [checked, setChecked] = useState(checkIfNameInStyleIntegrations());

	const findIntegrationFromArray = (): IntegrationType | undefined =>
		IntegrationsArray.find((item) => item.name === name);

	const addIntegration = () => {
		const newintegrations = style.integrationsStyle;
		const foundIntegration = findIntegrationFromArray();

		if (foundIntegration) newintegrations.push(foundIntegration);

		console.log(newintegrations);

		setStyle({
			...style,
			integrationsStyle: newintegrations
		});
	};

	const removeIntegration = () => {
		const newintegrations = style.integrationsStyle.filter(
			(item) => item.name != name
		);

		setStyle({
			...style,
			integrationsStyle: newintegrations
		});
	};

	const handleChange = () => {
		checked ? removeIntegration() : addIntegration();
		setChecked(!checked);
	};

	return (
		<div>
			<div className="flex items-center mb-4">
				<input
					id="default-checkbox"
					type="checkbox"
					checked={checked}
					onChange={handleChange}
					className="w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300
					focus:ring-blue-500 dark:focus:ring-blue-600"
				/>
				<label
					htmlFor="default-checkbox"
					className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300"
				>
					{slugName}
				</label>
			</div>
		</div>
	);
};
